/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Too_Many_Lines_TitleInputs */



/**
* | output |
* | --- |
* | "Too Many Lines" |
*
* @param {Embed_Captions_Too_Many_Lines_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_too_many_lines_title = /** @type {((inputs?: Embed_Captions_Too_Many_Lines_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Too_Many_Lines_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop de lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Zeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Troppe linee")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком много строк")
	if (locale === "es") return /** @type {LocalizedString} */ ("Demasiadas líneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("行数太多")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行が多すぎる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुत ज्यादा पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas em Excesso")
	return /** @type {LocalizedString} */ ("Too Many Lines")
});